import * as React from "react";
import { IconToClose, Wrapper, WrapperMessage } from "./MessagesStyled";
import KudosContext from "src/context";

export class MessagesComponent extends React.Component<{}> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  private static MILLIS_PER_SEC = 1000;

  public render() {
    return (
      <Wrapper show={this.context!.messages.length > 0}>
        {this.renderMessage()}
      </Wrapper>
    );
  }

  private renderMessage = () => {
    const { messages, removeMessage } = this.context!;
    return messages.length > 0
      ? messages
          .filter((m) => m.type !== "afterAddedKudos")
          .map((m) => {
            if (m.timeToHide) {
              setTimeout(() => {
                removeMessage(m);
              }, m.timeToHide * MessagesComponent.MILLIS_PER_SEC);
            }
            return (
              <WrapperMessage type={m.type} key={m.id}>
                {m.message}
                <IconToClose onClick={() => removeMessage(m)} />
              </WrapperMessage>
            );
          })
      : null;
  };
}
